(function(){
  'use strict';
  function containSticky(){
    if(document.body&&document.body.classList.contains('template-product'))return;
    ['#addtocart-sticky','#dp-global-sticky-atc','.dp-sticky[data-sticky-atc]'].forEach(function(selector){
      document.querySelectorAll(selector).forEach(function(node){node.hidden=true;node.setAttribute('aria-hidden','true');});
    });
    document.body&&document.body.classList.remove('dp-sticky-visible');
  }
  function boot(){containSticky();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  window.addEventListener('pageshow',boot);
  document.addEventListener('shopify:section:load',boot);
})();
